<template>
    <div class="home-page">
        <div  >
            <div>
                <div @click="back" class="back">
                    <img src="@/assets/imgs/back_r.png" alt="">
                    <span>返回系统</span>
                </div>

            </div>
            <div class="title" v-if="info.dangshi">
                <h1>{{info.dangshi.title}}</h1>
                <h2>{{info.dangshi.name}}</h2>
            </div>
        </div>


        <div class="list">
            <div class="title">
                <img src="@/assets/imgs/icon.png" alt="">
                <span>{{info.name}}</span>
                <span>{{info.title}}</span>
            </div>
            <div class="content">

                <div ref="contentRef" class="content1 desc">
                    <div v-html="info.content">

                    </div>
                </div>


                <div class="desc-img">
                    <img :src="'https://www.bndj.ncsvrcom.com'+info.image" alt="">
                    <p>{{info.image_desc}}</p>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    import {detail, save_visit} from '@/api/module/api'

    export default {
        name: "home",
        data() {
            return {
                visit_id: this.$route.query.visit_id,
                info: {}
            }

        }, created() {
            this.savePage();
            this.getIndex()
        },
        mounted() {
            this.initDiv()

        },
        methods: {
            initDiv() {
                const self = this
                const setInter = function () {
                    if (self.$refs.contentRef.scrollTop === self.$refs.contentRef.scrollHeight - self.$refs.contentRef.clientHeight) {
                        self.$refs.contentRef.scrollTop = 0
                    } else {
                        self.$refs.contentRef.scrollTop++
                    }
                }
                self.timer && clearInterval(self.timer)
                self.timer = setInterval(setInter, 60)


            },
            async savePage() {
                const {data} = await save_visit({
                    type: 4,
                    visit_id: this.visit_id
                })
            },
            async getIndex() {
                const {data} = await detail({id: this.visit_id});

                this.info = data;
            },
            back() {
                this.$router.go(-1)
            },

        }
    }
</script>

<style scoped>
    .content1 {
        height: 500px;
        overflow: hidden;
    }

    .home-page {
        width: 100vw;
        min-height: 100vh;
        background: url(../assets/imgs/detail_bg.png);
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
    }

    .home-page .title {
        color: #DB3127;
        font-size: 1.8vw;
        text-align: center;
        margin-top: -80px;
    }

    .home-page .title h2 {
        font-size: 1.6vw;
        margin-top: 10px;
    }

    .home-page .back {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 2.6vw 2.6vw 1vw 0;
    }

    .home-page .back img {
        width: 2.1vw;
        margin-right: 10px;
        /*margin-top: 6px;*/
    }

    .home-page .back span {
        color: #DB3127;
        font-size: 1.8vw;

    }

    .list {
        flex: 1;
        /*height: 80vh;*/
        background: #DB3127;
        border-radius: 0 0 4.2vw 0;
        margin: 2.8vw;
        padding: 1vw;
        border: 1.6vw solid #FACB6C;
        box-shadow: 0 0 20px rgba(145, 21, 14, 0.4), 0 -4px 2px 1px rgba(176, 29, 22, 0.7) inset, -1px 4px 4px 4px rgba(235, 141, 135, 0.7) inset,
        2px 0px 4px 4px rgba(176, 29, 22, 0.7) inset;


    }

    .list .title {
        display: flex;
        align-items: center;
    }

    .list .title img {
        width: 5vw;
    }

    .list .title {
        color: #FFF67B;
        font-size: 3.1vw;
        margin-top: 1vw;
        margin-left: 1vw;
    }

    .list .content {
        display: flex;
        color: white;
    }

    .desc {
        width: 57%;
        flex-shrink: 0;
        margin: 1% 2%;
        font-size: 1.4vw;
        text-indent: 3vw;
        line-height: 2.2vw;
    }

    .desc-img {
        flex: 1;
        margin-right: 2%;
        text-align: center;
        font-size: 1.4vw;
        margin-top: 1.7%;
    }

    .desc-img img {
        width: 100%;
        border: 2px solid white;
        margin-bottom: 0.5vw;
    }
</style>
